module.exports = __webpack_public_path__ + "static/media/PLAYER2.db0e65a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/PLAYER2.png
// module id = 266
// module chunks = 0